import React from 'react';
import { Container } from 'components/UI';
import { Image, Title } from '@landing/ui';

import * as styles from './About.module.scss';

export default function About({ title, quote, imageTop, textTop, imageBottom, textBottom }) {
  return (
    <Container id="about" className={styles.container}>
      <div className={styles.layout}>
        <div className={styles.top}>
          <div className={styles.topText}>
            <Title color="white">{title}</Title>
            <div className={styles.textWrapper}>
              {textTop.map(text => (
                <p key={text} className={styles.text}>
                  {text}
                </p>
              ))}
            </div>
          </div>
          <div className={styles.pictureTopWrapper}>
            <Image src={imageTop} className={styles.pictureTop} classImage={styles.img} />
            <blockquote className={styles.quote}>
              <p className={styles.quoteText}>{quote.text}</p>
              <footer className={styles.author}>{quote.author}</footer>
            </blockquote>
          </div>
        </div>
        <div className={styles.bottom}>
          <Image src={imageBottom} className={styles.pictureBottom} classImage={styles.img} />
          <p className={styles.text}>{textBottom}</p>
        </div>
      </div>
    </Container>
  );
}
